/* Frank IQSU + Ding Defenders theme script */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.FIQ || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- Mobile menu ---------- */
  var menuBtn = $("#menuBtn"), nav = $("#nav");
  if (menuBtn && nav) {
    menuBtn.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      menuBtn.setAttribute("aria-expanded", open);
    });
    $$("a", nav).forEach(function (a) {
      a.addEventListener("click", function () { nav.classList.remove("open"); menuBtn.setAttribute("aria-expanded", "false"); });
    });
  }

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove("on"); }, 2600);
  }

  /* ---------- Card grid: filter, search, sort ---------- */
  var grid = $("#grid");
  var filter = "all";

  function applyGrid() {
    if (!grid) return;
    var qEl = $("#q"), sortEl = $("#sort");
    var q = qEl ? qEl.value.trim().toLowerCase() : "";
    var sort = sortEl ? sortEl.value : "new";
    var items = $$(".item", grid);
    items.sort(function (a, b) {
      var A = a.dataset, B = b.dataset;
      var sold = Number(A.sold) - Number(B.sold);
      if (sold) return sold;
      if (sort === "low") return Number(A.price) - Number(B.price);
      if (sort === "high") return Number(B.price) - Number(A.price);
      if (sort === "year") return (Number(A.year) || 9999) - (Number(B.year) || 9999);
      return Number(B.added) - Number(A.added);
    });
    var shown = 0;
    items.forEach(function (el) {
      var ok = (filter === "all" || el.dataset.sport === filter) && (!q || el.dataset.search.indexOf(q) > -1);
      el.hidden = !ok;
      if (ok) shown++;
      grid.appendChild(el);
    });
    var empty = $("#gridEmpty");
    if (empty) empty.hidden = shown > 0 || items.length === 0;
  }

  function setFilter(f) {
    filter = f;
    $$("#seg button").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.f === f); });
    applyGrid();
  }

  if (grid) {
    var seg = $("#seg");
    if (seg) seg.addEventListener("click", function (e) { var b = e.target.closest("button[data-f]"); if (b) setFilter(b.dataset.f); });
    if ($("#q")) $("#q").addEventListener("input", applyGrid);
    if ($("#sort")) $("#sort").addEventListener("change", applyGrid);

    /* Same-page menu links (Basketball, Baseball...) filter instead of reloading */
    $$("a[data-go]").forEach(function (a) {
      a.addEventListener("click", function (e) {
        var url = new URL(a.href, location.href);
        if (url.pathname !== location.pathname) return;
        e.preventDefault();
        setFilter(a.dataset.go);
        var shop = $("#shop");
        if (shop) shop.scrollIntoView();
      });
    });

    var m = location.hash.match(/^#shop-(basketball|baseball|football|all)$/);
    if (m) { setFilter(m[1]); setTimeout(function () { var s = $("#shop"); if (s) s.scrollIntoView(); }, 0); }
    else applyGrid();
  }

  /* Sport tiles: counts come from the card grid on the same page */
  $$("[data-count-sport]").forEach(function (el) {
    if (!grid) { el.hidden = true; return; }
    var s = el.dataset.countSport;
    var n = $$(".item", grid).filter(function (i) { return i.dataset.sport === s && i.dataset.sold === "0"; }).length;
    el.textContent = n + (n === 1 ? " card available" : " cards available");
  });
  $$(".sport[data-sport]").forEach(function (tile) {
    tile.addEventListener("click", function () {
      if (!grid) { location.href = ROOT + "#shop-" + tile.dataset.sport; return; }
      setFilter(tile.dataset.sport);
      var shop = $("#shop");
      if (shop) shop.scrollIntoView();
    });
  });

  /* ---------- Add to cart (Shopify AJAX cart) ---------- */
  function updateCount() {
    fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$("[data-cart-count]").forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add-variant]");
    if (!b || b.disabled) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true;
    b.textContent = "Adding...";
    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.addVariant), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || "That item couldn't be added.");
        b.textContent = "In cart";
        updateCount();
        toast("Added to cart. Open Cart to check out.");
      })
      .catch(function (err) {
        b.disabled = false;
        b.textContent = label;
        toast(err.message);
      });
  });

  /* ---------- Formspree forms ---------- */
  $$("form[data-formspree]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var st = $(".status", f), btn = $("button[type=submit]", f);
      var bad = $$("[required]", f).find(function (i) {
        return !i.value.trim() || (i.type === "email" && !/^\S+@\S+\.\S+$/.test(i.value));
      });
      if (bad) {
        st.className = "status err";
        st.textContent = "Add your " + bad.closest("label").firstChild.textContent.trim().toLowerCase() + " to send.";
        bad.focus();
        return;
      }
      if (f.elements._gotcha && f.elements._gotcha.value) return;
      if (!f.action || f.action.indexOf("formspree.io") === -1) {
        st.className = "status err";
        st.textContent = "This form isn't connected yet. Email " + (CFG.email || "us") + ".";
        return;
      }
      var d = new FormData(f);
      if (f.dataset.subject) d.set("_subject", f.dataset.subject + " from " + (d.get("name") || ""));
      st.className = "status";
      st.textContent = "Sending...";
      btn.disabled = true;
      fetch(f.action, { method: "POST", body: d, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (res.ok) {
            st.className = "status ok";
            st.textContent = f.dataset.success || "Sent. We'll reply within two business days.";
            f.reset();
          } else {
            st.className = "status err";
            st.textContent = ((res.j.errors || []).map(function (x) { return x.message; }).join(" ") || "That didn't send.") +
              " Email " + (CFG.email || "us") + (CFG.phone ? " or text " + CFG.phone : "") + ".";
          }
        })
        .catch(function () {
          st.className = "status err";
          st.textContent = "No connection. Email " + (CFG.email || "us") + (CFG.phone ? " or text " + CFG.phone : "") + ".";
        })
        .then(function () { btn.disabled = false; });
    });
  });

  /* ---------- Supplies: Request buttons prefill the request form ---------- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-req]");
    if (!b || b.disabled) return;
    var text = $("#reqText");
    if (!text) return;
    e.preventDefault();
    text.value = b.dataset.req;
    var sel = $("#lineSelect");
    if (sel) {
      sel.selectedIndex = 0;
      if (b.dataset.line) {
        $$("option", sel).forEach(function (o, i) { if (o.textContent.indexOf(b.dataset.line) === 0) sel.selectedIndex = i; });
      }
    }
    var req = $("#request");
    if (req) req.scrollIntoView();
    text.focus();
  });
})();
